import { Icon } from "@iconify/react";
import React from "react";
import { useTranslation } from "react-i18next";
import { IoLocationOutline } from "react-icons/io5";


export default function Location() {
    const { t } = useTranslation();

    return <>
        <h1 className="pageTitle">{ t("location") }</h1>
        <label style={{fontSize : 18, padding : 10, justifyContent : "center", display : "flex", alignItems : "center"}}>
            <Icon icon="tabler:location" width="20" height="20" />
            {/* <IoLocationOutline size={20} style={{marginRight : 10}}/> */}
            Rua Nova, 24 E, Mosteiros, Ponta Delgada, Ilha de São Miguel
        </label>
        <div style={{
            display : "flex", 
            flexDirection : "row",
            flexWrap : "wrap",
            alignItems : "center",
            justifyContent : "center",
            gap : 20,
            marginBottom : 20,
        }}
            >
        <iframe 
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1574.3844553007511!2d-25.81707073261719!3d37.889086652469175!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xb4331921ebfe6cd%3A0x88784bf0ce259723!2sPadaria%20Paniconfianca!5e0!3m2!1spt-PT!2spt!4v1706988253471!5m2!1spt-PT!2spt" 
            style={{
                width : "min(80vw, 800px)", 
                height : "min(100vw,500px)",
                border : 0
            }}
            loading="lazy" 
            referrerPolicy="no-referrer-when-downgrade"
        />    
        <img 
            src={process.env.PUBLIC_URL + "/fachada_padaria.jpg"}
            style={{
                width : "min(75vw, 375px)", 
                height : "min(100vw,500px)",
                borderRadius : 20,
                marginTop : 20,
                aspectRatio: 0.75
            }}
        />
        </div>
    </>
}